<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addPublishment" v-if="permissionCodes.indexOf('035003001') !== -1"/>
      </div>
      <input-select selectTitle="发布状态" :selectKey="'status'" :selectData="publishmentTypeList" @search="search"/>
      <input-search placeholder="发布名称" @search="searchKey" />
    </div>
    <div class="search-line">
        <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine"  @goToModifyPage="goToModifyPage" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" @dataSummary="dataSummary" @closeQuestionnaire="closeQuestionnaire" tableOperationWidth="350px"/>

    <el-dialog
      title="数据汇总"
      :visible.sync="dialogVisible"
      width="60%"
      style="height:100%"
      :before-close="handleClose">
    <div class="search-line">
      <div class="btn-box">
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        download="download.xls"
        value="导出"/>
      </div>
      <input-select v-if="dialogVisible" selectTitle="答题状态" :selectKey="'answered'" :selectData="answeredTypeList" @search="search2"/>
      <input-search v-if="dialogVisible" placeholder="答题人姓名"  @search="searchKey2" />
    </div>
      <table-main :selection="false" :tableHeight="500" :tableHead="tableHead2" :tableData="tableData2"  :total="total2" :pageNum="requestData2.pageNum" :pageSize="requestData2.pageSize" :hasOperation="false" @changePagination="changePagination2" @downloadAppendix="downloadAppendix"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm" size="small">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Questionnaire";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "questionnaire-publishment-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "数据采集",
          name: "questionnaire-template-manage"
        },
        {
          value: "项目发布"
        }
      ],
      tableHead: [
        {
          prop: "publishName",
          label: "发布名称"
        },
        {
          prop: "projectName",
          label: "项目名称"
        },
        {
          prop: "publishDate",
          label: "发布时间"
        },
        {
          prop: "deadlineDate",
          label: "截止时间"
        },
        {
          prop: "Submitsend",
          label: "已提交/参与"
        },
        {
          prop: "publishStatus",
          label: "下线",
          closeQuestionnaire: true
        }
        // {
        //   prop: "publishStatus",
        //   label: "下线",
        //   active: " ",
        //   inactive: "已下线",
        //   isSwitch: true
        // }
      ],
      tableHead2: [],
      publishmentTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "发布"
        },
        {
          key: "0",
          label: "下线"
        }
      ],
      answeredTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: true,
          label: "已作答"
        },
        {
          key: false,
          label: "未作答"
        }
      ],

      addPublishment: "questionnaire-publishment-add",
      operationArr: ["dataSummary", "modify", "delete"],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        status: ""
        // publishStatus: ""
        // startTime: "",
        // endTime: "",
      },
      requestData2: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        publishCode: "",
        answered: ""
      },
      exportUrl: "",
      tableData: [],
      tableData2: [],
      total: 0,
      total2: 0,
      selectionArr: [],
      timevalue: [],
      dialogVisible: false,
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    // this.getPublishmentPage();
    this.getCreateTime();
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportAnswerData}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&publishCode=${
        this.requestData2.publishCode
      }&searchKey=${this.requestData2.searchKey}&answered=${
        this.requestData2.answered
      }`;
    },
    getPublishmentPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }

      this.$axios
        .post(api.getPublishmentPage, this.requestData)
        .then(res => {
          // console.log(res);
          let list = res.data.data.list;
          this.total = res.data.data.total;
          this.tableData = list;
          list.map(v => {
            v.Submitsend = v.submitCount + " / " + v.sendCount;
            if (v.status === "1") {
              v.publishStatus = true;
            } else {
              v.publishStatus = false;
            }
          });
        })
        .catch(errorHandler("获取分页失败"));
    },
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-01" + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPublishmentPage();
    },
    search(v) {
      this.requestData.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPublishmentPage();
    },
    search2(v) {
      this.requestData2.pageNum = 1;
      this.requestData2[v.key] = v.value;
      this.getAnswerList();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPublishmentPage();
    },
    searchKey2(v) {
      this.requestData2.pageNum = 1;
      this.requestData2.searchKey = v;
      this.getAnswerList();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPublishmentPage();
    },
    changePagination2(data) {
      this.requestData2.pageNum = data[0];
      this.requestData2.pageSize = data[1];
      // this.getQuestionList();
      this.getAnswerList();
    },
    deleteLine(code) {
      this.$axios
        .post(api.deletePublishmentByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getPublishmentPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/questionnaire_publishment_modify/${code}`
      });
    },
    dataSummary(data) {
      // console.log(data);
      this.requestData2 = {
        searchKey: "",
        pageSize: 10,
        pageNum: 1,
        publishCode: data.code,
        answered: ""
      };
      this.getQuestionList(data.code);
      this.dialogVisible = true;
    },
    getQuestionList(code) {
      this.$axios
        .get(api.getQuestionList + `/${code}`)
        .then(res => {
          let data = res.data.data;
          this.tableHead2.push({ label: "姓名" });
          this.tableHead2.push({ label: "是否作答" });
          data.map(v => {
            // console.log(v);
            let head = {};
            if (v.questionType === "7") {
              // head.downloadAppendix === "true";
              // console.log(v);
              head.downloadAppendix = true;
            }
            head.label = v.questionName;
            this.tableHead2.push(head);
          });
          // console.log(this.tableHead2);
          this.getAnswerList();
        })
        .catch(errorHandler("获取汇总列表失败"));
    },
    getAnswerList() {
      this.$axios
        .post(api.getAnswerList, this.requestData2)
        .then(res => {
          let data = res.data.data.list;
          this.total2 = res.data.data.total;
          let tableData2 = [];
          data.map(v => {
            v.answers.map((v, i) => {
              this.tableHead2[i + 2].prop = "textAnswer" + [i + 1];
            });
          });
          // console.log(data);
          this.tableHead2[0].prop = "personName";
          this.tableHead2[1].prop = "status";
          data.map(person => {
            // console.log(person);
            if (person.answered) {
              person.status = "是";
            } else {
              person.status = "否";
            }
            let obj = {
              personName: person.personName,
              status: person.status
            };
            person.answers.map((v, i) => {
              obj[`textAnswer${i + 1}`] = v.textAnswer;
            });
            tableData2.push(obj);
          });
          this.tableData2 = tableData2;
          // console.log(this.tableHead2);
          // console.log(this.tableData2);
        })
        .catch(errorHandler("获取答案列表失败"));
    },
    handleClose() {
      this.dialogVisible = false;
      this.tableHead2 = [];
      this.requestData2.searchKey = "";
    },
    confirm() {
      this.dialogVisible = false;
      this.tableHead2 = [];
    },
    downloadAppendix(data) {
      if (data) {
        window.open(data, "_blank");
        // downloadFile(data, data);
      }
    },
    closeQuestionnaire(data) {
      this.$confirm(
        "确定下线此问卷吗？下线之后将无法重新发布此项目，且用户无法填写！",
        "提示"
      )
        .then(() => {
          for (let i in data) {
            if (data[i] === "--") {
              data[i] = "";
            }
          }
          if (data.detailMap === "") {
            data.detailMap = null;
          }
          if (data.status == "1") {
            let data1 = {};
            data.status = "0";
            data1.status = data.status;
            data1.code = data.code;
            this.$axios
              .post(api.updatePublishment, data1)
              .then(res => {
                nSuccess("修改成功");
                this.getPublishmentPage();
              })
              .catch(errorHandler("修改失败"));
          } else {
            nError("已下线的项目无法发布");
            this.getPublishmentPage();
          }
        })
        .catch(() => {
          this.getPublishmentPage();
        });
    }
  },
  watch: {
    timevalue(val) {
      this.getPublishmentPage();
    }
  }
};
</script>

<style scoped>
.form-line {
  width: 420px;
  margin: 20px auto;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.red {
  color: red;
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/view/Questionnaire/QuestionnairePublish/QuestionnairePublishmentManage.vue